import {gql} from '@apollo/client';

export const LIST_EXTENSIONS_QUERY = gql`
  query ListExtensions($extensionType: ExtensionType!) @skipAudit @engComponent(name: EXTENSIONS) {
    extensionLabelSpecs(extensionType: $extensionType) {
      key
      displayName
      placement
    }
    extensionRegistryListing(extensionType: $extensionType) {
      items {
        id
        name
        isOwnedByBenchling
        tagLine
        description
        extensionType
        createdAt
        modifiedAt
        installationId
        installApprovalRequired
        installApprovalText
        provider {
          name
          url
        }
        links {
          documentation {
            url
            text
          }
          policy {
            url
            text
          }
        }
        latestVersion {
          id
          versionId
          description
          mcpProperties {
            serverUrl
            urlParams {
              key
              label
              description
              options
            }
          }
        }
        labels {
          key
          value
          displayName
        }
      }
    }
  }
`;

export const EXTENSION_VERSIONS_QUERY = gql`
  query ExtensionVersions($extensionDefinitionId: StrictString!) @skipAudit @engComponent(name: EXTENSIONS) {
    extensionVersions(extensionDefinitionId: $extensionDefinitionId) {
      items {
        id
        versionId
        description
        createdAt
        modifiedAt
      }
      versionTags
    }
  }
`;
